import React, { useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import services from "../../../services";
import { changeactive } from "../services";

function Service(props) {
  let history = useHistory();
  function goToService(id) {
    let url = `/service?id=${id}`;
    history.push(url);
  }
  const ref = useRef();
  useEffect(() => {
    if (parseInt(props.urlId) === parseInt(props.id)) {
      ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, []);
  return (
    <li
      className="service"
      title={props.title}
      onClick={() => {
        props.mainContent(services[props.id - 1]);
        changeactive(props.id);
        goToService(props.id);
        props.categoryChange(props.category);
      }}
      id={`lgcatbutton${props.id}`}
      ref={ref}
    >
      {props.title}
    </li>
  );
}

export default Service;
